// extracted by mini-css-extract-plugin
export default {"priceBreakdownMobile":"price-breakdown_priceBreakdownMobile__XxifY"};